import { EditOutlined } from "@mui/icons-material";
import {
  Button,
  Checkbox,
  Col,
  Form,
  Input,
  message,
  Modal,
  Radio,
  Row,
  Space,
  Switch,
  TimePicker,
} from "antd";
import dayjs from "dayjs";
import EditSelectTable from "molecules/EditSelectTable";
import TabsList from "molecules/TabsList";
import FormModal from "organisms/FormModal";
import React, { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import {
  useHistory,
  useLocation,
} from "react-router-dom/cjs/react-router-dom.min";
import {
  getAllDepartmentList,
  getClientid,
  getLocations,
  getShiftList,
  getUserInfo,
  getUserList,
} from "redux/selectors";
import styled from "styled-components";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import { CALL_API } from "common/API";
import { STATUS_CODE } from "common/Constants";
import { ButtonOutlined } from "reusableComponent/UIButtons";

const StyledButton = styled(Button)`
  background: #26a4ff;
  border-radius: 5px;
  color: #ffffff;
  width: auto;
  margin: 5px;
`;

const StyledModal = styled(Modal)`
  .color-grid {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
    margin: 16px 0;
  }

  .circle {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    cursor: pointer;
    border: 2px solid transparent;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .circle.active {
    border: 2px solid #000;
  }

  .tick {
    font-size: 14px;
    color: #000;
  }

  .preview-box {
    margin-top: 16px;
    padding: 20px;
    text-align: center;
    font-weight: bold;
    border-radius: 8px;
    font-size: 18px;
  }
`;

const EditShift = () => {
  const departmentList = useSelector(getAllDepartmentList);
  const shiftList = useSelector(getShiftList);
  const locationList = useSelector(getLocations);
  const ClientId = useSelector(getClientid);
  const userInfo = useSelector(getUserInfo);
  const userList = useSelector(getUserList);
  const location = useLocation();
  const shiftColors = location?.state?.shiftColors || [];
  const [form] = Form.useForm();
  const history = useHistory();
  const colors = [
    "#C5F3F9",
    "#A3E7F2",
    "#D1F4E8",
    "#FCD9F4",
    "#F9D3D3",
    "#E9D1FD",
    "#DAD7FE",
    "#FFECA9",
    "#FFEDC2",
    "#FFD3A3",
    "#FFCFB3",
    "#D8E9FF",
    "#C3E0C7",
    "#A6E3A1",
    "#8EE58C",
    "#78D67F",
    "#FFD1D1",
    "#FFADAD",
    "#FDE8E8",
    "#C3C3C3",
    "#F3F3F3",
    "#D3E5FF",
    "#FFBC99",
    "#FFA37B",
    "#FFEC99",
  ];
  const shiftData = location.state.shiftData || {};
  const [formValues, setFormValues] = useState({});
  const [titleColor, setTitleColor] = useState(shiftData?.color);
  const viewOnly = location.state.viewOnly || false;
  const containerRef = useRef(null);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [selectedColor, setSelectedColor] = useState(titleColor);
  const [loader, setLoader] = useState(false);
  const [selectedLocationId, setSelectedLocationId] = useState([]);
  const [selectDepartmentId, setSelectDepartmentId] = useState([]);
  const [selectAllDepartmentsChecked, setSelectAllDepartmentsChecked] =
    useState(false);
  const [selectAllLocationChecked, setSelectAllLocationChecked] =
    useState(false);
  const [openDepartmentModal, setOpenDepartmentModal] = useState(false);
  const [openLocationModal, setOpenLocationModal] = useState(false);

  const filterLocationList = locationList?.filter(
    (item) => item?.login_from_anywhere !== 1
  );
  console.log("formvalues-->", formValues);
  const handleSubmit = async (values) => {
    console.log("values-->", values);
    setLoader(true);
    const finduser = userList?.find((user) => user.userid === userInfo?.userid);
    const { code } = await CALL_API(
      `update-shift/${ClientId}/${shiftData.shift_id}`,
      "patch",
      {
        shifttitle: formValues.shifttitle,
        shiftcode: formValues.shiftcode,
        starts: formValues.starts,
        ends: formValues.ends,
        status: formValues.status,
        isholiday: formValues.isholiday,
        isweekend: formValues.isweekend,
        location: selectedLocationId,
        department: selectDepartmentId,
        color: titleColor,
        updateduser: userInfo?.name,
        updatedemployeeid: finduser?.employeeid,
        starttime: formValues.starts.format("HH:mm"),
        endtime: formValues.ends.format("HH:mm"),
      }
    );
    if (code === STATUS_CODE.SUCCESS) {
      setLoader(false);
      message.success("Shift updated successfully.");
      history.push("/shift");
    } else {
      setLoader(false);
      message.error("Failed to update shift. Please try again.");
    }
  };

  const departmentcolumns = [
    {
      title: "Department Name",
      dataIndex: "department_name",
      key: "department_name",
      width: "10%",
    },
    {
      title: "Access Level",
      dataIndex: "department_id",
      key: "department_id",
      width: "10%",
      align: "center",
      render: (department_id) => {
        const check = selectDepartmentId?.includes(department_id)
          ? true
          : false;
        return (
          <Switch
            disabled={viewOnly}
            checked={check}
            size="small"
            onChange={(checked) => getDepartmentId(department_id, checked)}
          />
        );
      },
    },
  ];

  const getDepartmentId = (department_id, checked) => {
    const newDepartmentId = checked
      ? [...selectDepartmentId, department_id]
      : selectDepartmentId.filter((item) => item !== department_id);
    setSelectDepartmentId(newDepartmentId);
  };

  const handleSelectAllDepartmentsChange = (e) => {
    const checked = e.target.checked;
    setSelectAllDepartmentsChecked(checked);
    const allDepartmentIds = departmentList.map((item) => item.department_id);
    setSelectDepartmentId(checked ? allDepartmentIds : []);
  };

  const locatincolumns = [
    {
      title: "Location Name",
      dataIndex: "location_name",
      key: "location_name",
      width: "10%",
    },
    {
      title: "Access Level",
      dataIndex: "location_id",
      key: "location_id",
      width: "10%",
      align: "center",
      render: (location_id) => {
        const check = selectedLocationId?.includes(location_id) ? true : false;
        return (
          <Switch
            disabled={viewOnly}
            size="small"
            checked={check}
            onChange={(checked) => getLocationId(location_id, checked)}
          />
        );
      },
    },
  ];

  const getLocationId = (location_id, checked) => {
    const newLocationId = checked
      ? [...selectedLocationId, location_id]
      : selectedLocationId.filter((item) => item !== location_id);
    setSelectedLocationId(newLocationId);
  };

  const handleSelectAllLocationChange = (e) => {
    const checked = e?.target?.checked;
    setSelectAllLocationChecked(checked);
    const allDepaetmentIds = filterLocationList.map((item) => item.location_id);
    setSelectedLocationId(checked ? allDepaetmentIds : []);
  };

  useEffect(() => {
    const startTime = shiftData?.starts ? dayjs(shiftData?.starts) : null;
    const endTime = shiftData?.ends ? dayjs(shiftData?.ends) : null;

    setFormValues({
      shifttitle: shiftData?.shifttitle || "",
      shiftcode: shiftData?.shiftcode || "",
      starts: startTime,
      ends: endTime,
      status: shiftData?.status || "active",
      isholiday: shiftData?.isholiday || "no",
      isweekend: shiftData?.isweekend || "allsaturdayandsunday",
    });

    form.setFieldsValue({
      shifttitle: shiftData?.shifttitle || "",
      shiftcode: shiftData?.shiftcode || "",
      starts: startTime,
      ends: endTime,
      status: shiftData?.status || "active",
      isholiday: shiftData?.isholiday || "no",
      isweekend: shiftData?.isweekend || "allsaturdayandsunday",
      color: shiftData?.color || "#C5F3F9",
    });

    setTitleColor(shiftData?.color || "#C5F3F9");
    setSelectedLocationId(shiftData.location);
    setSelectDepartmentId(shiftData.department);
    setSelectAllLocationChecked(
      selectDepartmentId?.length === departmentList?.length
    );
  }, [shiftData]);

  useEffect(() => {
    setSelectAllLocationChecked(
      selectedLocationId.length === filterLocationList.length
    );
    setSelectAllDepartmentsChecked(
      selectDepartmentId.length === departmentList.length
    );
  }, [selectedLocationId, locationList, selectDepartmentId, departmentList]);
  console.log("formvalues-->", formValues);

  const showConfirm = (values) => {
    Modal.confirm({
      title:
        "Remember, holidays are counted as working days for the employees on this shift.",

      okText: "Okay, Include",
      cancelText: "Don't Include",
      okButtonProps: {
        loading: loader,
      },
      onOk: async () => {
        form.setFieldValue("isholiday", "yes");
      },
      onCancel: async () => {
        form.setFieldValue("isholiday", "no");
      },
    });
  };

  const items = [
    {
      id: 1,
      label: "Basic",
      component: (
        <>
          {viewOnly ? (
            <Row className="styled-card">
              <Col>
                <b>Shift Title</b> : {formValues?.shifttitle}
                <b>Shift Code</b> : {formValues?.shiftcode}
                <b>Starts</b> : {dayjs(formValues?.starts).format("hh:mm A")}
                <b>Ends</b> : {dayjs(formValues?.ends).format("hh:mm A")}
                <b>Status</b> : {formValues?.status}
                <b>
                  Do you want to designate holidays as working days for this
                  shift?
                </b>{" "}
                : {formValues?.isholiday}
                <b>Weekends for this shift</b> : {formValues?.isweekend}
              </Col>
            </Row>
          ) : (
            <Form
              form={form}
              name="EditShift"
              layout="vertical"
              initialValues={formValues}
              onValuesChange={(changedValues, allValues) => {
                setFormValues(allValues);
              }}
            >
              <Row gutter={12} className="g-3 mb-2">
                <Col
                  xs={24}
                  sm={24}
                  md={12}
                  lg={12}
                  xl={12}
                  style={{ display: "flex", alignItems: "center", gap: "8px" }}
                >
                  <Form.Item
                    label="Shift Title"
                    name="shifttitle"
                    style={{ flex: 1 }}
                    rules={[
                      {
                        required: true,
                        message: "Please enter Shift Title",
                      },
                      {
                        validator: (_, value) => {
                          if (typeof value === "string" && value.trim()) {
                            const trimmedValue = value.trim();
                            if (
                              shiftData?.shifttitle !== trimmedValue &&
                              shiftList.some(
                                (data) => data.shifttitle === trimmedValue
                              )
                            ) {
                              return Promise.reject(
                                new Error("Shift name already exists")
                              );
                            }
                          }
                          return Promise.resolve();
                        },
                      },
                    ]}
                  >
                    <Input
                      placeholder="Shift Title"
                      maxLength={15}
                      onKeyDown={(e) => {
                        const allowedChars = /^[a-zA-Z\s]+$/;
                        if (!allowedChars.test(e.key)) {
                          e.preventDefault();
                        }
                      }}
                    />
                  </Form.Item>

                  <Form.Item
                    label=""
                    name="color"
                    rules={[
                      { required: false, message: "Please select a color" },
                    ]}
                  >
                    <div
                      className="color-box "
                      style={{
                        backgroundColor: titleColor,
                        width: "35px",
                        height: "35px",
                        marginTop: "30px",
                        borderRadius: "6px",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        cursor: "pointer",
                        border: "1px solid #d9d9d9",
                      }}
                      onClick={() => setIsModalVisible(true)}
                    >
                      <EditOutlined />
                    </div>
                  </Form.Item>
                </Col>

                <Col xs={24} sm={24} md={12} lg={12} xl={12} ref={containerRef}>
                  <Form.Item
                    label="Shift Code (Max 5 characters)"
                    name="shiftcode"
                    rules={[
                      {
                        required: true,
                        message: "Please enter shift Code",
                      },
                      {
                        validator: (_, value) => {
                          if (typeof value === "string" && value.trim()) {
                            const trimmedValue = value.trim();
                            if (
                              shiftData?.shiftcode !== trimmedValue &&
                              shiftList.some(
                                (data) => data.shiftcode === trimmedValue
                              )
                            ) {
                              return Promise.reject(
                                new Error("Shift code already exists")
                              );
                            }
                          }
                          return Promise.resolve();
                        },
                      },
                    ]}
                  >
                    <Input
                      maxLength={5}
                      placeholder="Shift Code"
                      onKeyDown={(e) => {
                        const allowedChars = /^[a-zA-Z\s]+$/;
                        if (!allowedChars.test(e.key)) {
                          e.preventDefault();
                        }
                      }}
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={24} md={12} lg={12} xl={12} ref={containerRef}>
                  <Form.Item
                    label="Starts"
                    name="starts"
                    rules={[
                      {
                        required: true,
                        message: "Please enter shift start time",
                      },
                    ]}
                  >
                    <TimePicker
                      className="w-100"
                      placeholder="Starts"
                      format="hh:mm A"
                      use12Hours
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={24} md={12} lg={12} xl={12} ref={containerRef}>
                  <Form.Item
                    label="Ends"
                    name="ends"
                    rules={[
                      {
                        required: true,
                        message: "Please enter shift end time",
                      },
                    ]}
                  >
                    <TimePicker
                      className="w-100"
                      placeholder="Ends"
                      format="hh:mm A"
                      use12Hours
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={24} md={12} lg={12} xl={12} ref={containerRef}>
                  <Form.Item
                    label="Status"
                    name="status"
                    rules={[
                      {
                        required: true,
                        message: "Please Select Status",
                      },
                    ]}
                  >
                    <Radio.Group
                      placeholder="Radio.Group"
                      getPopupContainer={() => containerRef.current}
                    >
                      <Radio value="active">Active</Radio>
                      <Radio value="inactive">Inactive</Radio>
                    </Radio.Group>
                  </Form.Item>
                </Col>
                <Col xs={24} sm={24} md={12} lg={12} xl={12} ref={containerRef}>
                  <Form.Item
                    label="Do you want to designate holidays as working days for this shift?"
                    name="isholiday"
                    rules={[
                      {
                        required: true,
                        message:
                          "Please select do you want to designate holidays as working days for this shift?",
                      },
                    ]}
                  >
                    <Radio.Group
                      placeholder="Radio.Group"
                      getPopupContainer={() => containerRef.current}
                      onChange={(e) =>
                        e.target.value === "no" ? null : showConfirm(e)
                      }
                    >
                      <Radio value="yes">Yes</Radio>
                      <Radio value="no">No</Radio>
                    </Radio.Group>
                  </Form.Item>
                </Col>
                <Col xs={24} sm={24} md={12} lg={12} xl={12} ref={containerRef}>
                  <Form.Item
                    label="Weekends for this shift"
                    name="isweekend"
                    rules={[
                      {
                        required: true,
                        message: "Please Radio.Group weekend for this shift?",
                      },
                    ]}
                  >
                    <Radio.Group
                      placeholder="Radio.Group"
                      getPopupContainer={() => containerRef.current}
                      direction="vertical"
                    >
                      <Space direction="vertical">
                        <Radio value="allsaturdayandsunday">
                          All Saturdays and Sundays
                        </Radio>
                        <Radio value="allsaturdays">All Saturdays</Radio>
                        <Radio value="allsundays">All Sundays</Radio>
                        <Radio value="alldays">All Days</Radio>
                        <Radio value="noweekends">No Weekends</Radio>
                      </Space>
                    </Radio.Group>
                  </Form.Item>
                </Col>
              </Row>
            </Form>
          )}
        </>
      ),
    },
    // {
    //   id: 2,
    //   label: "Department",
    //   component: (
    //     <>
    //       {!viewOnly && (
    //         <div className="mb-3 d-flex justify-content-between">
    //           {departmentList?.length > 0 && (
    //             <Checkbox
    //               className=""
    //               checked={selectAllDepartmentsChecked}
    //               onChange={handleSelectAllDepartmentsChange}
    //             >
    //               Select All
    //             </Checkbox>
    //           )}
    //         </div>
    //       )}
    //       <EditSelectTable
    //         columns={departmentcolumns}
    //         tabledata={departmentList}
    //         setOpenModal={() => setOpenDepartmentModal(true)}
    //         Name="Add Department"
    //       />
    //       <FormModal
    //         isModalVisible={openDepartmentModal}
    //         closeModal={() => setOpenDepartmentModal(false)}
    //         Name="Department"
    //       />
    //     </>
    //   ),
    // },
    // {
    //   id: 3,
    //   label: "Location",
    //   component: (
    //     <>
    //       {!viewOnly && (
    //         <div className="mb-3 d-flex justify-content-between">
    //           {filterLocationList?.length > 0 && (
    //             <Checkbox
    //               className=""
    //               checked={selectAllLocationChecked}
    //               onChange={handleSelectAllLocationChange}
    //             >
    //               Select All
    //             </Checkbox>
    //           )}
    //         </div>
    //       )}

    //       <EditSelectTable
    //         columns={locatincolumns}
    //         tabledata={filterLocationList}
    //         setOpenModal={() => setOpenLocationModal(true)}
    //         Name="Add Location"
    //       />
    //       <FormModal
    //         isModalVisible={openLocationModal}
    //         closeModal={() => setOpenLocationModal(false)}
    //         Name="Location"
    //       />
    //     </>
    //   ),
    // },
  ];

  const footerStyle = {
    position: "sticky",
    bottom: 0,
    left: 0,
    right: 0,
    backgroundColor: "#fff",
    padding: "10px",
    display: "flex",
    justifyContent: "end",
    boxShadow: "0 2px 10px rgba(0, 0, 0, 0.1)",
    margin: "0px -20px",
  };
  return (
    <div>
      <label
        className="bg-transparent border-0 mb-3 text-left styled-cursor"
        onClick={() => {
          history.push("shift");
        }}
      >
        Shift <ArrowForwardIosIcon className="px-1" />
      </label>{" "}
      <b className=" pb-0 pt-1">Editing Shift</b>
      <TabsList items={items} style={{ height: "100vh" }} />
      <div className="w-100 text-end mt-3">
        {!viewOnly && (
          <>
            <ButtonOutlined onClick={() => history.push("shift")}>
              Cancel
            </ButtonOutlined>
            <StyledButton
              type="primary"
              className="px-3"
              onClick={() => {
                handleSubmit();
              }}
              loading={loader}
            >
              Save Changes
            </StyledButton>
          </>
        )}
      </div>
      <StyledModal
        title="Choose a colour for Shift"
        open={isModalVisible}
        onCancel={() => setIsModalVisible(false)}
        width={400}
        footer={[
          <Button
            key="cancel"
            onClick={() => {
              setSelectedColor(titleColor);
              setIsModalVisible(false);
            }}
          >
            Cancel
          </Button>,
          <Button
            key="choose"
            type="primary"
            onClick={() => {
              setTitleColor(selectedColor);
              setIsModalVisible(false);
            }}
          >
            Choose
          </Button>,
        ]}
      >
        <div className="color-grid">
          {colors.map((color) => {
            const isDisabled =
              shiftColors?.includes(color) && shiftData?.color !== color;

            return (
              <div
                key={color}
                className={`circle ${color === selectedColor ? "active" : ""} ${
                  isDisabled ? "disabled" : ""
                }`}
                style={{
                  backgroundColor: color,
                  opacity: isDisabled ? 0.4 : 1,
                  cursor: isDisabled ? "not-allowed" : "pointer",
                  pointerEvents: isDisabled ? "none" : "auto", // prevents click
                }}
                onClick={() => {
                  if (!isDisabled) {
                    setSelectedColor(color);
                  }
                }}
              >
                {(color === selectedColor ||
                  (shiftColors?.includes(color) &&
                    shiftData?.color !== color)) && (
                  <span className="tick">✓</span>
                )}
              </div>
            );
          })}
        </div>
        <div
          style={{
            border: "1px dashed #d9d9d9",
            padding: "10px",
            borderRadius: "6px",
          }}
        >
          <label>Preview:</label>
          <div
            className="preview-box"
            style={{ backgroundColor: selectedColor }}
          >
            {form.getFieldValue("shifttitle") || "Shift Name"}
          </div>
        </div>
      </StyledModal>
    </div>
  );
};

export default EditShift;
